import Icons from 'components/Icons'
import { Mask } from 'utils/masks'

import Container, { FieldGroup, InputContainer, Error } from './styles'

function TextField({ config, formik, handleKeyUp }) {
  const {
    label,
    labelwidth,
    inputwidth,
    readOnly,
    name,
    prefix,
    suffix,
    mask,
    type = 'text',
    disabled = false,
    placeholder,
    clearable = false,
  } = config
  const error = formik.errors[name]

  function handleChange(name, e) {
    const res = Mask[mask](e)
    const value = res.currentTarget.value
    formik.setFieldValue(name, value)
  }

  function handleClear() {
    formik.setFieldValue(name, '')
  }

  // function handleKeyUp(e) {
  //   onKeyUp(e)
  // }
  return (
    <>
      <Container className={readOnly ? 'read-only' : ''}>
        <FieldGroup width={labelwidth}>
          <label className={`${error ? 'error' : ''}`} htmlFor={name}>
            {label}
          </label>
          <InputContainer
            className={`${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}
            width={inputwidth}
          >
            {prefix && <div className="prefix">{prefix}</div>}
            {!mask ? (
              <>
                <input
                  type={type}
                  name={name}
                  onChange={formik.handleChange}
                  value={formik.values[name] ?? ''}
                  disabled={disabled}
                  placeholder={placeholder}
                  onKeyUp={handleKeyUp}
                />
                {clearable && formik.values[name]?.length > 0 && (
                  <button
                    className="clear-icon"
                    onClick={handleClear}
                    type="button"
                  >
                    <Icons icon="closeSmall" />
                  </button>
                )}
              </>
            ) : (
              <>
                <input
                  type="text"
                  name={name}
                  value={formik.values[name] ?? ''}
                  onChange={(e) => handleChange(name, e)}
                  disabled={disabled}
                  placeholder={placeholder}
                  onKeyUp={handleKeyUp}
                />
                {clearable && formik.values[name]?.length > 0 && (
                  <button
                    className="clear-icon"
                    onClick={handleClear}
                    type="button"
                  >
                    <Icons icon="closeSmall" />
                  </button>
                )}
              </>
            )}
            {suffix && <div className="suffix">{suffix}</div>}
          </InputContainer>
        </FieldGroup>

        <Error>{error}</Error>
      </Container>
    </>
  )
}

export default TextField
